// extracted by mini-css-extract-plugin
export default {"primaryColour":"#1f2937","secondaryColour":"#f0bc74"};